type RouteHandler = (employee?: string) => string;

const routeConfig: Record<string, RouteHandler> = {
  Laundry: (employee) => (employee ? "/v1/employee/home" : "/v1/home"),
  Restaurant: () => "/v1/Reshome",
  Carwash: () => "/v1/new-order",
  "Car wash": () => "/v1/new-order",
  "Vechicle retailer": () => "/v1/vechicle-home",
  Saloon: () => "/v1/saloon-Home",
  Grocery: () => "/grocery/home",
};

export const useBusinessRoutes = () => {
  const getRouteForBusiness = (business_type: string, employee?: string) => {
    const handler = routeConfig[business_type];
    return handler ? handler(employee) : "/";
  };

  return { getRouteForBusiness };
};
